import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from '../i/icons_d.png';

const baseUrl555 = 'https://www.555.comcast.com';
const styles = {
  box: {
    width: '1112px',
    margin: 'auto',
    position: 'relative',
    top: '-85px',
    overflow: 'hidden',
  },
  landingHeading: {
    fontSize: '35px',
    fontWeight: '500',
    color: '#282828',
    textAlign: 'center',
    margin: 0,
    padding: 0,
  },
  landingDescTxt: {
    lineHeight: '27px',
    fontSize: '13px',
    color: '#282828',
    textAlign: 'center',
    width: '758px',
    margin: 'auto',
    padding: '25px 0 53px 0',
  },
  listWrapper: {
    lineHeight: '27px',
    borderRadius: '10px',
    WebkitBoxShadow: '0px 0px 21px 3px rgba(0,0,0,0.06)',
    MozBoxShadow: '0px 0px 21px 3px rgba(0,0,0,0.06)',
    boxShadow: '0px 0px 21px 3px rgba(0,0,0,0.06)',
    minHeight: '331px',
    margin: '0 0 116px 0',
    padding: 0,
  },
  listItem: {
    zIndex: '99',
    background: '#fff',
    float: 'left',
    width: '50%',
    position: 'relative',
    minHeight: '331px',
    listStyle: 'none',
    '&:before': {
      content: '""',
      width: '1px',
      height: '249px',
      backgroundColor: '#efefef',
      position: 'absolute',
      top: '41px',
      right: '0',
    },
  },
  icon: {
    position: 'absolute',
    left: '0',
    right: '0',
    margin: 'auto',
    top: '78px',
    display: 'block',
    background: `url(${Image}) no-repeat`,
    backgroundSize: '750px 340px',
  },
  downloadIcon: {
    width: '78px',
    height: '75px',
    backgroundPosition: '-338px -244px',
  },
  createIcon: {
    width: '78px',
    height: '65px',
    backgroundPosition: '-435px -244px',
  },
  boxTitle: {
    display: 'table',
    fontSize: '24px',
    color: '#334956',
    fontWeight: '500',
    margin: '175px auto 0 auto',
    outline: 'none',
    textDecoration: 'none',
  },
  boxDescription: {
    fontSize: '14px',
    color: '#464646',
    lineHeight: '22px',
    textAlign: 'center',
    width: '436px',
    margin: '12px auto 0 auto',
  },
};

const boxContents = [
  {
    iconClass: 'downloadIcon',
    title: 'Download SDKs',
    url: 'https://www.555.comcast.com',
    description: '',
  },
  {
    iconClass: 'createIcon',
    title: 'Create Your App',
    url: '',
    description: '',
  },
];
const HowItWorks = ({ classes }) => (
  <div>
    <div className={classes.box}>
      {/* <p className={classes.landingDescTxt} /> */}
      <div className={classes.listWrapper}>
        <ul>
          {boxContents.map(item => (
            <a key={item.title} href={baseUrl555 + item.url}>
              <li className={classes.listItem}>
                <span className={classNames(classes.icon, classes[item.iconClass])} />
                <span className={classes.boxTitle}>{item.title}</span>
                <p className={classes.boxDescription}>{item.description}</p>
              </li>
            </a>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default withStyles(styles)(HowItWorks);

HowItWorks.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
};

HowItWorks.defaultProps = {
  classes: {},
};
